import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: JSON.parse(localStorage.getItem("cart")) || [],
  totalAmount: 0,
};

const MAX_QUANTITY = 20;

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    initializeCart(state, action) {
      const loadedItems = action.payload;
      state.items = loadedItems;
    
      // Recalculate totalAmount
      state.totalAmount = loadedItems.reduce(
        (sum, item) => sum + item.productPrice * item.quantity,
        0
      );
    },
    
    addToCart(state, action) {
      const product = action.payload;
      const MAX_QUANTITY = 20;
    
      // Step 1: Check for exact match (same ID + same objectColors)
      const sameVariantIndex = state.items.findIndex(
        (item) =>
          item.productID === product.productID &&
          JSON.stringify(item.objectColors) === JSON.stringify(product.objectColors)
      );
    
      if (sameVariantIndex !== -1) {
        // ✅ Same product and same variant
        if (state.items[sameVariantIndex].quantity < MAX_QUANTITY) {
          state.items[sameVariantIndex].quantity += 1;
          state.totalAmount += product.productPrice;
        }
      } else {
        // Step 2: Check if same productID but different variant exists
        const sameIDIndex = state.items.findIndex(
          (item) => item.productID === product.productID
        );
    
        if (sameIDIndex !== -1) {
          // 🔄 Replace old variant with new one
          const oldItem = state.items[sameIDIndex];
          state.totalAmount -= oldItem.productPrice * oldItem.quantity;
    
          state.items[sameIDIndex] = { ...product, quantity: product.quantity };
          state.totalAmount += product.productPrice * product.quantity;
        } else {
          // 🆕 New product
          state.items.push({ ...product, quantity: product.quantity });
          state.totalAmount += product.productPrice * product.quantity;
        }
      }
    },
    
    updateQuantity(state, action) {
      const { productID, quantity } = action.payload;
      const itemToUpdate = state.items.find(
        (item) => item.productID === productID
      );
      if (itemToUpdate) {
        const difference = quantity - itemToUpdate.quantity;
        if (quantity <= MAX_QUANTITY) {
          itemToUpdate.quantity = quantity;
          state.totalAmount += difference * itemToUpdate.productPrice;
        } else {
          itemToUpdate.quantity = MAX_QUANTITY;
          state.totalAmount +=
            (MAX_QUANTITY - itemToUpdate.quantity) * itemToUpdate.productPrice;
        }
      }
    },
    removeFromCart(state, action) {
      const productId = action.payload;
      const itemToRemove = state.items.find(
        (item) => item.productID === productId
      );
      if (itemToRemove) {
        state.totalAmount -= itemToRemove.productPrice * itemToRemove.quantity;
        state.items = state.items.filter(
          (item) => item.productID !== productId
        );
      }
    },
  },
});

export const { initializeCart, addToCart, removeFromCart, updateQuantity } = cartSlice.actions;

export const selectCartItems = (state) => state.cart.items;
export const selectCartTotalAmount = (state) => state.cart.totalAmount;

export default cartSlice.reducer;
